import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { getFingerprint } from "@thumbmarkjs/thumbmarkjs";

// The shape of the API response on success
export interface ICheckBlockedResponse {
    Valid: boolean;
    BrowserFingerprint: string;
}

// A narrowed return type for the query: it may return a valid object or false
type CheckBlockedQueryResult = ICheckBlockedResponse | false;

const checkBlocked = async (): Promise<CheckBlockedQueryResult> => {
    const fingerprint: string = await getFingerprint();

    const payload = {
        BrowserFingerprint: fingerprint,
    };

    const axiosAuth = createAxiosClient("Auth");

    const response = await axiosAuth.post<CheckBlockedQueryResult>(
        "/UILogin/ValidateRequest",
        JSON.stringify(payload),
        {
            headers: { "Content-Type": "application/json" },
        }
    );

    return response.data;
};

export const useCheckBlocked = () =>
    useQuery<CheckBlockedQueryResult>({
        queryFn: checkBlocked,
        queryKey: ["checkBlocked"],
        refetchOnWindowFocus: false,
        retry: false,
    });
